/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var scrollAnimationFrame = null;
  var kitemarkVariantListenerBound = false;

  function getCssVarNumber(name) {
    var value = getComputedStyle(document.documentElement).getPropertyValue(name);
    var parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function getHeaderOffset() {
    var stickyEnabled = getCssVarNumber('--header-is-sticky');
    var headerHeight = getCssVarNumber('--header-height');

    if (stickyEnabled > 0 && headerHeight > 0) {
      return headerHeight;
    }

    var fallbackHeader = document.querySelector('.shopify-section--header, .shopify-section-group-header-group');
    return fallbackHeader ? fallbackHeader.getBoundingClientRect().height : 0;
  }

  function normalizeHash(rawHash) {
    if (!rawHash) return '';
    var clean = String(rawHash).trim().replace(/^#+/, '');
    return clean ? '#' + clean : '';
  }

  function easeInOutSine(progress) {
    return -(Math.cos(Math.PI * progress) - 1) / 2;
  }

  function animateWindowScroll(targetY) {
    var startY = window.pageYOffset;
    var distance = targetY - startY;
    var duration = Math.min(950, Math.max(450, Math.abs(distance) * 0.55));
    var startTime = null;

    if (scrollAnimationFrame) {
      cancelAnimationFrame(scrollAnimationFrame);
      scrollAnimationFrame = null;
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var easedProgress = easeInOutSine(progress);

      window.scrollTo(0, startY + distance * easedProgress);

      if (progress < 1) {
        scrollAnimationFrame = requestAnimationFrame(step);
      } else {
        scrollAnimationFrame = null;
      }
    }

    scrollAnimationFrame = requestAnimationFrame(step);
  }

  function scrollToHash(hash, smooth) {
    var normalizedHash = normalizeHash(hash);
    if (!normalizedHash) return;

    var targetId = normalizedHash.slice(1);
    var decodedTargetId = decodeURIComponent(targetId);
    var target = document.getElementById(targetId) || document.getElementById(decodedTargetId);
    if (!target) return;

    var y = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    var targetY = Math.max(0, y);

    if (smooth) {
      animateWindowScroll(targetY);
      return;
    }

    window.scrollTo(0, targetY);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.se-scroll-link[href^="#"]');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var hash = normalizeHash(link.getAttribute('href'));
    if (!hash) return;
    scrollToHash(hash, true);
  }, true);

  window.addEventListener('load', function () {
    var pageHash = normalizeHash(window.location.hash);
    if (pageHash && document.querySelector('a.se-scroll-link[href="' + pageHash + '"]')) {
      scrollToHash(pageHash, false);
    }
  });

  function isThirtyThirtyVariant(variant) {
    if (!variant) return false;

    var candidateParts = [];
    if (variant.title) candidateParts.push(String(variant.title));
    if (variant.option1) candidateParts.push(String(variant.option1));
    if (variant.option2) candidateParts.push(String(variant.option2));
    if (variant.option3) candidateParts.push(String(variant.option3));
    if (Array.isArray(variant.options)) {
      for (var i = 0; i < variant.options.length; i += 1) {
        if (variant.options[i]) candidateParts.push(String(variant.options[i]));
      }
    }

    var text = candidateParts.join(" ").toLowerCase();
    return /30\s*(mm)?\s*[-/]\s*30\s*(mm)?/.test(text);
  }

  function isThirtyThirtyFromDom() {
    var selectedValues = document.querySelectorAll('.product-form__option .product-form__selected-value');
    var text = "";

    for (var i = 0; i < selectedValues.length; i += 1) {
      text += " " + (selectedValues[i].textContent || "");
    }

    if (!text.trim()) {
      var checkedInputs = document.querySelectorAll('.product-form input[type="radio"]:checked, .product-form select');
      for (var j = 0; j < checkedInputs.length; j += 1) {
        var el = checkedInputs[j];
        var value = el.tagName === 'SELECT' ? el.options[el.selectedIndex] && el.options[el.selectedIndex].text : el.value;
        text += " " + (value || "");
      }
    }

    return /30\s*(mm)?\s*[-/]\s*30\s*(mm)?/i.test(text);
  }

  function toggleKitemarkBadge(variant) {
    var blocks = document.querySelectorAll('.se-certified-icons-block[data-kitemark-warning-enabled="true"]');
    if (!blocks.length) return;

    var shouldHide = variant ? isThirtyThirtyVariant(variant) : isThirtyThirtyFromDom();
    for (var i = 0; i < blocks.length; i += 1) {
      var grid = blocks[i].querySelector('.se-certified-icons-block__grid');
      if (!grid || !grid.lastElementChild) continue;
      var item = grid.lastElementChild;
      if (!item) continue;
      item.hidden = shouldHide;
    }
  }

  function bindKitemarkVariantBehavior() {
    if (!kitemarkVariantListenerBound) {
      document.addEventListener('variant:changed', function (event) {
        toggleKitemarkBadge(event && event.detail ? event.detail.variant : null);
      });
      kitemarkVariantListenerBound = true;
    }

    var variantScript = document.querySelector('variant-picker script[data-variant]');
    if (variantScript) {
      try {
        var initialVariant = JSON.parse(variantScript.textContent || '{}');
        toggleKitemarkBadge(initialVariant);
        return;
      } catch (error) {
      }
    }

    toggleKitemarkBadge(null);
    window.setTimeout(function () {
      toggleKitemarkBadge(null);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindKitemarkVariantBehavior);
  } else {
    bindKitemarkVariantBehavior();
  }
})();
